import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import { Reveal, RevealStagger, RevealItem } from "@/components/Reveal";
import { IMAGES, PROCESS } from "@/lib/site";

export default function ManufacturingSection() {
     return (
   
      <section data-testid="process-section" className="relative py-24 md:py-36 bg-white">
         {/* MANUFACTURING PROCESS */}
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16 items-end">
            <Reveal className="lg:col-span-5">
              <div className="overline text-stenzia-green"><span className="kbd-line" /> Manufacturing Process</div>
              <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-[60px] tracking-tighter text-charcoal leading-[1.02]">
                From CAD to crate.<br />Six precise steps.
              </h2>
              <p className="mt-6 text-charcoal/65 leading-relaxed">
                Every Stenzia stand passes through a six-stage process inside our 35,000 sq ft factory in Morbi. CNC precision meets craftsman finishing.
              </p>
              <Link to="/manufacturing" data-testid="process-explore-btn" className="mt-8 btn-secondary text-sm inline-flex group">
                Explore the factory <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
            </Reveal>
            <Reveal delay={1} className="lg:col-span-7 relative rounded-3xl overflow-hidden min-h-[440px] shadow-2xl">
              <img src={IMAGES.Homec2c} alt="Stenzia manufacturing facility" loading="lazy" className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-[2000ms]" />
              <div className="absolute inset-0 bg-gradient-to-tr from-charcoal/40 via-transparent to-transparent" />
            </Reveal>
          </div>

          {/* Timeline */}
          <div className="relative">
            <div className="absolute left-0 right-0 top-12 h-px bg-charcoal/10 hidden lg:block" />
            <RevealStagger className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6 relative">
              {PROCESS.map((p) => (
                <RevealItem key={p.step}>
                  <div data-testid={`process-step-${p.step}`} className="relative pt-12">
                    <div className="absolute top-0 left-0 w-6 h-6 rounded-full bg-stenzia-green ring-4 ring-white shadow-md flex items-center justify-center">
                      <div className="w-1.5 h-1.5 rounded-full bg-white" />
                    </div>
                    <div className="font-display text-stenzia-gold text-xs font-semibold tracking-[0.3em]">{p.step}</div>
                    <h3 className="mt-3 font-display text-lg md:text-xl text-charcoal tracking-tight">{p.title}</h3>
                    <p className="mt-2 text-sm text-charcoal/60 leading-relaxed">{p.body}</p>
                  </div>
                </RevealItem>
              ))}
            </RevealStagger>
          </div>
        </div>
      </section>

     );
}